import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Footer = () => (
  <footer className="bg-taxi-darker border-t border-border">
    <div className="container-custom py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src="/logo.png" alt="Trichy to Velankanni Taxi" className="h-12 w-auto object-contain" />
            <span className="text-xl font-bold text-foreground">
              trichytovelankanni.taxi
            </span>
          </div>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Your trusted taxi service in Trichy. Affordable, safe, and reliable cab booking for local, airport and outstation travel across Trichy.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-foreground font-semibold mb-4">Quick Links</h3>
          <div className="flex flex-col gap-2">
            {[
              { label: "Home", path: "/" },
              { label: "Services", path: "/services" },
              { label: "Tariff", path: "/pricing" },
              { label: "About Us", path: "/about" },
              { label: "Blog", path: "/blog" },
              { label: "Contact", path: "/contact" },
            ].map((l) => (
              <Link key={l.path} to={l.path} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Popular Routes */}
        <div>
          <h3 className="text-foreground font-semibold mb-4">Popular Routes</h3>
          <div className="flex flex-col gap-2">
            {[
              { label: "Trichy to Tanjore", path: "/routes/trichy-to-tanjore" },
              { label: "Trichy to Madurai", path: "/routes/trichy-to-madurai" },
              { label: "Trichy to Dindigul", path: "/routes/trichy-to-dindigul" },
              { label: "Trichy to Kumbakonam", path: "/routes/trichy-to-kumbakonam" },
            ].map((l) => (
              <Link key={l.path} to={l.path} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-foreground font-semibold mb-4">Contact Us</h3>
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-2">
              <a href="tel:+917418749974" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
                <Phone className="w-4 h-4 text-primary" /> +91 7418 749 974
              </a>
            </div>
            <a href="mailto:[EMAIL_ADDRESS]" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
              <Mail className="w-4 h-4 text-primary" /> info@trichytovelankanni.taxi
            </a>
            <div className="flex items-start gap-2 text-sm text-muted-foreground">
              <MapPin className="w-4 h-4 text-primary mt-0.5" /> No.9 kpn complex, melachintamani, Trichy
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="w-4 h-4 text-primary" /> 24/7 Available
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="container-custom py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} trichytovelankanni.taxi. All rights reserved.
        </p>
        <p className="text-xs text-muted-foreground">
          Best taxi service in Trichy | Cab booking Trichy
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
